import {
  SET_FORM_DATA,
  SET_FORM_LOADING,
  SET_CUISINE_TYPE_ID,
  SET_DESCRIPTION,
  SET_FORM_TYPE_ID,
  SET_HEATING_REQUIRED,
  SET_IMAGE_PATH,
  SET_IS_ACTIVE,
  SET_IS_SPECIAL,
  SET_IS_VEG,
  SET_MEAL_TYPE_ID,
  SET_NAME,
  SET_PACKAGING_WEIGHT,
  SET_PRODUCT_ID,
  SET_QUANTITY_TYPE_ID,
  SET_QUANTITY_VALUE,
  SET_SERVING,
  SET_SHELF_LIFE,
  SET_TAX_TYPE_ID,
  SET_TITLE,
  SET_SUBMIT_LOADING
} from './constants';

const initialState = {
  formData: {
    cuisineTypes: [],
    formTypes: [],
    mealTypes: [],
    quantityTypes: [],
    taxTypes: [],
    products: []
  },
  loading: true,
  name: '',
  title: '',
  description: '',
  productId: 0,
  quantityTypeId: 0,
  formTypeId: 0,
  mealTypeId: 0,
  cuisineTypeId: 0,
  taxTypeId: 0,
  isSpecial: 0,
  isVeg: 0,
  isActive: 1,
  shelfLife: 0,
  serving: 0,
  microwaveHeatingRequired: 0,
  quantityValue: 0,
  withPackagingWeight: 0,
  imagePath: '',
  submitLoading: false
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_FORM_DATA:
      return {
        ...state,
        formData: action.formData
      };

    case SET_FORM_LOADING:
      return {
        ...state,
        loading: action.loading
      };

    case SET_CUISINE_TYPE_ID:
      return {
        ...state,
        cuisineTypeId: action.cuisineTypeId
      };
    case SET_DESCRIPTION:
      return {
        ...state,
        description: action.description
      };
    case SET_FORM_TYPE_ID:
      return {
        ...state,
        formTypeId: action.formTypeId
      };
    case SET_HEATING_REQUIRED:
      return {
        ...state,
        microwaveHeatingRequired: action.microwaveHeatingRequired
      };
    case SET_IMAGE_PATH:
      return {
        ...state,
        imagePath: action.imagePath
      };
    case SET_IS_ACTIVE:
      return {
        ...state,
        isActive: action.isActive
      };
    case SET_IS_SPECIAL:
      return {
        ...state,
        isSpecial: action.isSpecial
      };
    case SET_IS_VEG:
      return {
        ...state,
        isVeg: action.isVeg
      };
    case SET_MEAL_TYPE_ID:
      return {
        ...state,
        mealTypeId: action.mealTypeId
      };
    case SET_NAME:
      return {
        ...state,
        name: action.name
      };
    case SET_PACKAGING_WEIGHT:
      return {
        ...state,
        withPackagingWeight: action.withPackagingWeight
      };
    case SET_PRODUCT_ID:
      return {
        ...state,
        productId: action.productId
      };
    case SET_QUANTITY_TYPE_ID:
      return {
        ...state,
        quantityTypeId: action.quantityTypeId
      };
    case SET_QUANTITY_VALUE:
      return {
        ...state,
        quantityValue: action.quantityValue
      };
    case SET_SERVING:
      return {
        ...state,
        serving: action.serving
      };
    case SET_SHELF_LIFE:
      return {
        ...state,
        shelfLife: action.shelfLife
      };
    case SET_TAX_TYPE_ID:
      return {
        ...state,
        taxTypeId: action.taxTypeId
      };
    case SET_TITLE:
      return {
        ...state,
        title: action.title
      };
    case SET_SUBMIT_LOADING:
      return {
        ...state,
        submitLoading: action.submitLoading
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/Modules/CreateNewVariant/reducer.js